import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicOrganisationTrial } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getTrials = async (
  organisationId: string,
): Promise<PublicOrganisationTrial[]> => {
  const response = await axiosClient.get(
    `/organisation-trials/${organisationId}/active`,
  );
  return response.data;
};

export const getTrialsQueryKey = (organisationId: string) => [
  "trials",
  organisationId,
];

export function useTrials(
  organisationId: string,
  queryOptions?: Partial<UseQueryOptions<PublicOrganisationTrial[], HttpError>>,
) {
  return useQuery({
    queryKey: getTrialsQueryKey(organisationId),
    queryFn: () => getTrials(organisationId),
    ...queryOptions,
  });
}
